import { createPinia } from 'pinia'
import { createSentryPiniaPlugin } from '@sentry/vue'

export function registerPinia(app) {
  const pinia = createPinia()
  pinia.use(createSentryPiniaPlugin())
  app.use(pinia)
}
